import { buildENV } from "../../config.json";

/**
 * [initPendo description]
 * 	This initalizes the Pendo Help system in the application
 * 		The Pendo script should be added to the DOM in `index.html`
 * 	This function takes the user object and sets some initial information on Pendo for tracking
 * 		For full documentation of Pendo object please see Pendo Docs
 *
 * 		To prevent application breaking things, we wrap both groups in a try/catch
 * 		This allows our Application to work regardless of the status of Pendo
 * 		*************************************************************
 * 		 We DO NOT WANT TO BREAK OUR APP if a 3rd party script fails
 *    	*************************************************************
 *
 * @param  {object} userInfo User object from crm/v1/user
 *                           Each application's `user/` endpoint returns slightly different data
 *                           The `visitor` object will need to be adjusted based on the data returned
 *                           	We should always have access to:
 *                           	id
 *                           	email
 *                           	full_name
 *
 * @return {undefined}          Nothing
 */
export function initPendo(userInfo = {}) {
	if (/dev/gi.test(buildENV)) {
		console.info("%cPendo%c is %cdisabled%c for local testing", "color: #40b658; font-weight:bold;", "color:#fff; font-weight:normal;", "color:red; font-weight:bold;", "color:#fff; font-weight:normal;");
		console.log();
		return;
	}

	try {
		const {
			businessEntity,
			department = {},
			securityGroup = {},
			profileRole = {},
			location = {},
			id,
			email,
			name,
		} = userInfo;
		// eslint-disable-next-line no-undef
		pendo.initialize({
			account: businessEntity,
			visitor: {
				department_name: department.name,
				department_id: department.id,
				securityGroup_name: securityGroup.description,
				securityGroup_id: securityGroup.id,
				profileRole_name: profileRole.name,
				profileRole_id: profileRole.id,
				location_name: location.name,
				location_id: location.id,
				id,
				email,
				full_name: name,
				environment: buildENV,
				product: "Creative Manager",
				language: navigator.language,
			},
		});
	} catch (err) {
		/* eslint-disable indent */
		console.groupCollapsed("Pendo Init Problem");
		console.error("Problem Starting up Pendo");
		console.error(err);
		console.groupEnd();
		/* eslint-enable indent */
	}
}
